import request from '@/utils/request'

export function rmsEquipConfirmGetall(params) {
  return request({
    url: '?c=rms&a=confirm&do=getall',
    method: 'get',
    params
  })
}

export function rmsEquipConfirmList(params) {
  return request({
    url: '?c=rms&a=confirm&do=list',
    method: 'get',
    params
  })
}

export function rmsEquipConfirmSingle(data) {
  return request({
    url: '?c=rms&a=confirm&do=single',
    method: 'post',
    data
  })
}

export function rmsEquipConfirmBatch(data) {
  return request({
    url: '?c=rms&a=confirm&do=batch',
    method: 'post',
    data
  })
}
